export default [
  // 申请加群
  {
    path: '/group/apply',
    component: () => import('./views/apply')
  },
  // 等待审核
  {
    path: '/group/apply/result',
    component: () => import('./views/apply/result')
  },
  // 聊天室
  {
    path: '/group/chat',
    component: () => import('./views/chat')
  },
  // 圈子设置
  {
    path: '/group/set',
    component: () => import('./views/set')
  },
  // 常见问题
  {
    path: '/group/cjwt',
    component: () => import('./views/cjwt')
  },
  // 常见问题搜索
  {
    path: '/group/cjwt/search',
    component: () => import('./views/cjwt/search')
  },
  // 找医生咨询
  {
    path: '/group/doc',
    component: () => import('./views/doc')
  },
  // 二维码
  {
    path: '/group/ercode',
    component: () => import('./views/ercode')
  }
]



// WEBPACK FOOTER //
// ./src/page/group/router.js